import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  baseUrl: string = environment.reqBaseUrl + 'notifications/';
  headers: HttpHeaders = new HttpHeaders();

  constructor(private http: HttpClient) {}

  getNotifications() {
    return this.http.get(this.baseUrl, {
      observe: 'response',
    });
  }

  notificationsViewed(userId: string) {
    return this.http.post(this.baseUrl + 'user/' + userId, null, {
      observe: 'response',
    });
  }

  notificationClicked(notificationId: string) {
    return this.http.post(this.baseUrl + notificationId, null, {
      observe: 'response',
    });
  }
}
